import {FWU_TARGET_TYPES} from '../../consts/fwu/fwuTargetTypes';
// import {IDevice, IDeviceEngine, IHolder, IHolderEngine, IIotDevice} from '../../models/iotDevice';

// const isFwuTargetDevice = (fwuTarget: FWU_TARGET_TYPES): boolean => fwuTarget === FWU_TARGET_TYPES.CHARGER_OR_MONO;
// const isFwuTargetHolderEngine = (fwuTarget: FWU_TARGET_TYPES): boolean => fwuTarget === FWU_TARGET_TYPES.HOLDER_ENGINE;
// const isFwuTargetBleStack = (fwuTarget: FWU_TARGET_TYPES): boolean => fwuTarget === FWU_TARGET_TYPES.BLE_STACK;

// const isFwuTargetRequiresUsbConnection = (fwuTarget: FWU_TARGET_TYPES, doesDeviceSupportSblUpdate: boolean): boolean =>
//     fwuTarget === FWU_TARGET_TYPES.BLE_STACK ||
//     (fwuTarget === FWU_TARGET_TYPES.HOLDER_DEVICE && !doesDeviceSupportSblUpdate) ||
//     (fwuTarget === FWU_TARGET_TYPES.HOLDER_ENGINE && !doesDeviceSupportSblUpdate) ||
//     (isFwuTargetRequiresSblTypeUpdate(fwuTarget) && !doesDeviceSupportSblUpdate);

const isFwuTargetRequiresSblTypeUpdate = (fwuTarget: FWU_TARGET_TYPES): boolean =>
    fwuTarget === FWU_TARGET_TYPES.HOLDER_DEVICE ||
    fwuTarget === FWU_TARGET_TYPES.HOLDER_ENGINE ||
    fwuTarget === FWU_TARGET_TYPES.MONO_ENGINE;

const isFwuTargetHolderRelated = (fwuTarget?: FWU_TARGET_TYPES): boolean =>
    fwuTarget === FWU_TARGET_TYPES.HOLDER_DEVICE || fwuTarget === FWU_TARGET_TYPES.HOLDER_ENGINE;

// const getIotTargetByFwuTarget = (
//     iotDevice: IIotDevice,
//     fwu_target: FWU_TARGET_TYPES
// ): IDevice | IDeviceEngine | IHolder | IHolderEngine | undefined => {
//     const iotTargetName = getIotTargetNameByFwuTarget(fwu_target);

//     return iotDevice ? iotDevice[iotTargetName] : undefined;
// };

// const getFwuTargetByIotTarget = (iotDevice: IIotDevice): FWU_TARGET_TYPES | undefined => {
//     const {device, device_engine, holder, holder_engine, ble_stack} = iotDevice || {};

//     if (device) {
//         return FWU_TARGET_TYPES.CHARGER_OR_MONO;
//     } else if (device_engine) {
//         return FWU_TARGET_TYPES.MONO_ENGINE;
//     } else if (ble_stack) {
//         return FWU_TARGET_TYPES.BLE_STACK;
//     } else if (holder) {
//         return FWU_TARGET_TYPES.HOLDER_DEVICE;
//     } else if (holder_engine) {
//         return FWU_TARGET_TYPES.HOLDER_ENGINE;
//     }
// };

// const getIotTargetNameByFwuTarget = (fwu_target: FWU_TARGET_TYPES): IOT_DEVICE_TARGET_NAMES => {
//     switch (fwu_target) {
//         case FWU_TARGET_TYPES.MONO_ENGINE:
//             return IOT_DEVICE_TARGET_NAMES.DEVICE_ENGINE;
//         case FWU_TARGET_TYPES.BLE_STACK:
//             return IOT_DEVICE_TARGET_NAMES.BLE_STACK;
//         case FWU_TARGET_TYPES.HOLDER_DEVICE:
//             return IOT_DEVICE_TARGET_NAMES.HOLDER;
//         case FWU_TARGET_TYPES.HOLDER_ENGINE:
//             return IOT_DEVICE_TARGET_NAMES.HOLDER_ENGINE;
//         case FWU_TARGET_TYPES.CHARGER_OR_MONO:
//         default:
//             return IOT_DEVICE_TARGET_NAMES.DEVICE;
//     }
// };

export default {
    // getFwuTargetByIotTarget,
    // getIotTargetByFwuTarget,
    // getIotTargetNameByFwuTarget,
    // isFwuTargetDevice,
    // isFwuTargetHolderEngine,
    isFwuTargetHolderRelated,
    // isFwuTargetRequiresUsbConnection,
    // isFwuTargetBleStack,
    isFwuTargetRequiresSblTypeUpdate,
};
